import "./custom.scss";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import VueBootstrapTypeahead from "vue-bootstrap-typeahead";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

import Cloudinary, { CldImage, CldTransformation } from "cloudinary-vue";

Vue.component("vue-bootstrap-typeahead", VueBootstrapTypeahead);

Vue.config.productionTip = false;

// Install BootstrapVue
Vue.use(BootstrapVue);

// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

Vue.use(Cloudinary, {
  configuration: { cloudName: "p1nkx3l", api_key: 212549332487821 },
  components: {
    CldImage,
    CldTransformation,
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
